import React from 'react';
import * as Actions from 'app/store/actions';
import ConfirmDialog from './utils/ConfirmDialog';

function builMessageProvider(store) {
	return {
		messageProvider: {
			messageBefore: message =>
				new Promise(function (resolve, reject) {
					store.dispatch(
						Actions.openDialog({
							children: <ConfirmDialog cbConfirm={resolve} message={message} moduleName="application" />
						})
					);
				}),
			messageAfter: message =>
				new Promise(function (resolve) {
					store.dispatch(
						Actions.showMessage({
							message: message,
							variant: 'success'
						})
					);
					return resolve(true);
				}),
			messageError: message =>
				new Promise(function (resolve) {
					store.dispatch(
						Actions.showMessage({
							message: message,
							variant: 'error'
						})
					);
					return resolve(true);
				})
		}
	};
}

export default builMessageProvider;
